import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchReportWidget, selectReportingV2Filters } from '@/store/slices/reportingV2/reportingV2Slice';
import { useCallback } from 'react';
import { ALL_WIDGETS, buildGroupedRequest, buildRequest } from '../widgets';

/**
 * Fires every widget's `/reporting-v2/report` query from the current filters.
 * `loadAll` is filter-dependent, so calling it on mount and whenever filters
 * change refetches the whole page.
 */
export const useReportingV2 = () => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(selectReportingV2Filters);

  const loadAll = useCallback(() => {
    for (const widget of ALL_WIDGETS) {
      dispatch(fetchReportWidget({ key: widget.key, request: buildRequest(widget, filters) }));
    }
    if (filters.grouping !== 'all') {
      dispatch(fetchReportWidget({ key: 'grouped', request: buildGroupedRequest(filters.grouping, filters) }));
    }
  }, [dispatch, filters]);

  return { loadAll };
};
